import { useApi } from "@/composition/useApi.js";

export default {
  state: () => ({
    errorTextRequest: null,
    companiesModalIsShow: false,
    allCompanies: [],
    setSpinerCompanies: true,
    data: {
      id: null,
      parentFolderId: null,
      isEditing: false,
      nameCompany: "",
    },
  }),
  mutations: {
    setCompaniesList(state, payload) {
      state.allCompanies = payload;
    },
    setCompaniesModalVisibility(state, bool) {
      state.companiesModalIsShow = bool;
    },
    setSpinerCompanies(state, bool) {
      state.setSpinerCompanies = bool;
    },
    setData(state, payload) {
      state.data.id = payload.id;
      state.data.parentFolderId = payload.parentFolderId;
      state.data.isEditing = payload.isEditing;
      state.data.nameCompany = payload.nameCompany;
    },
    setCompanyErrorTextRequest(state, text) {
      state.errorTextRequest = text;
      setTimeout(() => (state.errorTextRequest = null), 5000);
    },
  },
  actions: {
    getCompaniesList({ commit }) {
      const { api } = useApi();
      commit("setSpinerCompanies", true);
      return api
        .get(`/folders/nested`, { version: "v2" })
        .then(r => {
          if (r.status === 200) {
            commit("setCompaniesList", r.data);
            commit("setSpinerCompanies", false);
          }
          return r.status;
        })
        .catch(err => {
          commit("setSpinerCompanies", false);
          commit("setCompanyErrorTextRequest", err.message);
        });
    },
    createItem({ dispatch, commit }, item) {
      const { api } = useApi();
      return api
        .post("/folders", item)
        .then(r => {
          dispatch("getCompaniesList");
          return r.status;
        })
        .catch(err => {
          commit("setCompanyErrorTextRequest", err.message);
        });
    },
    updateItem({ dispatch, commit }, item) {
      const { api } = useApi();
      return api
        .put(`/v1/folders/${item.id}`, {
          name: item.name,
          parentFolderId: item.parentFolderId,
        })
        .then(r => {
          dispatch("getCompaniesList");
          return r.status;
        })
        .catch(err => {
          commit("setCompanyErrorTextRequest", err.message);
        });
    },
    removeCompany({ dispatch }, id) {
      const { api } = useApi();
      return api.delete(`/v1/folders/${id}`).then(r => {
        dispatch("getCompaniesList");
        return r.status;
      });
    },
    searchCompanies({ commit }) {
      commit("setSpinerCompanies", true);
      alert("Поиск временно недоступен");
      return [];
      // return api
      //   .get(`/folders/search`, {
      //     params: {
      //       name: name,
      //     },
      //   })
      //   .then(r => {
      //     if (r.status === 200) {
      //       commit("setCompaniesList", r.data);
      //       commit("setSpinerCompanies", false);
      //     }
      //     return r.status;
      //   })
      //   .catch(err => {
      //     commit("setSpinerCompanies", false);
      //     commit("setCompanyErrorTextRequest", err.message);
      //   });
    },
  },
};
